// extracted by mini-css-extract-plugin
export var subtitle = "_dh-2";
export var title = "_dh-0";
export var titleNoWrap = "_dh-1";